import HeaderComponent from "./header";

function Header(props) {
  return <HeaderComponent {...props} />;
}

export default Header;
